import React from 'react';
import {resolveRenderer} from './detail_renderers/registry';
import {GenericDetailTable} from './detail_renderers/primitives/GenericDetailTable';
import {DetailRenderGuard} from './detail_renderers/DetailRenderGuard';

// Shell del panel de detalle: resuelve el renderer por tipo/forma (registry) y lo envuelve
// en un error boundary local — un detail inesperado degrada al render genérico, nunca
// rompe la fila. Acepta {entry} (forma nueva) o {detail} suelto (compat).
//
// El fallback va con su PROPIO guard (fallback null): si el genérico también lanza con ese
// payload, el panel queda vacío en vez de escalar el error al boundary de la app.
export function ActivityLogDetail({entry, detail}) {
    const resolved = entry || {detail};
    const detailData = resolved.detail;
    if (!detailData || typeof detailData !== 'object') return null;

    const {Component} = resolveRenderer(resolved);
    if (!Component) return null;

    const fallback = Component === GenericDetailTable
        ? null
        : (
            <DetailRenderGuard fallback={null}>
                <GenericDetailTable detail={detailData}/>
            </DetailRenderGuard>
        );

    return (
        <DetailRenderGuard fallback={fallback}>
            <Component detail={detailData} entry={resolved}/>
        </DetailRenderGuard>
    );
}
